import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Typography,
  Container,
  Button,
  Paper,
} from '@mui/material';
import { useTranslation } from '../common/components/LocalizationProvider';
import BaseCommandView from './components/BaseCommandView';
import PageLayout from '../common/components/PageLayout';
import SettingsMenu from './components/SettingsMenu';
import { useCatch } from '../reactHelper';
import useSettingsStyles from './common/useSettingsStyles';
import fetchOrThrow from '../common/util/fetchOrThrow';
import { usePremiumTokens } from '../common/theme/usePremiumTokens';

const CommandDevicePage = () => {
  const navigate = useNavigate();
  const { classes } = useSettingsStyles();
  const t = useTranslation();
  const tokens = usePremiumTokens();

  const { id } = useParams();

  const [savedId, setSavedId] = useState(0);
  const [item, setItem] = useState({});

  const handleSend = useCatch(async () => {
    let command;
    if (savedId) {
      const response = await fetchOrThrow(`/api/commands/${savedId}`);
      command = await response.json();
    } else {
      command = item;
    }

    command.deviceId = parseInt(id, 10);

    await fetchOrThrow('/api/commands/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(command),
    });
    navigate(-1);
  });

  const validate = () => savedId || (item && item.type);

  return (
    <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'deviceCommand']}>
      <Container maxWidth={false} className={classes.container}>
        <Paper
          elevation={0}
          sx={{
            p: 3,
            borderRadius: tokens.radius.lg,
            backgroundColor: tokens.surface.card,
            border: `1px solid ${tokens.border.subtle}`,
          }}
        >
          <Typography variant="h6" sx={{ mb: 3, color: tokens.text.primary }}>
            {t('sharedRequired')}
          </Typography>
          <BaseCommandView
            deviceId={id}
            item={item}
            setItem={setItem}
            includeSaved
            savedId={savedId}
            setSavedId={setSavedId}
          />
        </Paper>
        <div className={classes.buttons}>
          <Button
            type="button"
            color="primary"
            variant="outlined"
            onClick={() => navigate(-1)}
            sx={{
              borderRadius: tokens.radius.md,
              borderColor: tokens.border.default,
              '&:hover': { borderColor: tokens.accent.primary },
            }}
          >
            {t('sharedCancel')}
          </Button>
          <Button
            type="button"
            color="primary"
            variant="contained"
            onClick={handleSend}
            disabled={!validate()}
            sx={{
              borderRadius: tokens.radius.md,
              backgroundColor: tokens.accent.primary,
              '&:hover': { backgroundColor: tokens.accent.hover },
            }}
          >
            {t('commandSend')}
          </Button>
        </div>
      </Container>
    </PageLayout>
  );
};

export default CommandDevicePage;
